import { render, staticRenderFns } from "./Checkpoints.vue?vue&type=template&id=122f2fd9&"
import script from "./Checkpoints.vue?vue&type=script&lang=js&"
export * from "./Checkpoints.vue?vue&type=script&lang=js&"
import style0 from "./Checkpoints.vue?vue&type=style&index=0&id=122f2fd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports